import * as yup from 'yup'
import * as linkSchemas from '../link/Link.schema'
import { createDataSchema, createPropertiesSchema, createDataRef } from '../schemaUtils'

export type TextAlignment = 'left' | 'center' | 'right' | 'justify'
export type A11yRole = 'heading' | 'status' | 'alert'
export type AriaLive = 'polite' | 'assertive'
export type AriaCurrent = 'step' | 'page' | 'true' | 'false'

export const styledTextA11y = createDataSchema(
	'StyledTextA11y',
	yup.object({
		label: yup.string().max(1000),
		live: yup.mixed<AriaLive>().oneOf(['polite', 'assertive']),
		level: yup.number().min(1).max(6),
		role: yup.mixed<A11yRole>().oneOf(['heading', 'status', 'alert']),
		atomic: yup.boolean(),
		hidden: yup.boolean(),
		current: yup.mixed<AriaCurrent>().oneOf(['step', 'page', 'true', 'false']),
	})
)

export type StyledTextA11y = yup.InferType<typeof styledTextA11y>

export const dataSchema = createDataSchema(
	'StyledText',
	yup.object({
		usedFonts: yup.array(yup.string()).default(['font_7']),
		text: yup.string().max(120000).default("<p class='font_7'></p>"),
		stylesMapId: yup.string(),
		linkList: yup.array(createDataRef(linkSchemas)).nullable(),
		a11y: createDataRef({ StyledTextA11y: styledTextA11y }).nullable(),
	})
)

export const propertiesSchema = createPropertiesSchema(
	'WRichTextProperties',
	yup.object({
		packed: yup.bool().default(false),
		verticalText: yup.bool().default(false),
		brightness: yup.number().default(1),
		overrideAlignment: yup.mixed<TextAlignment>().oneOf(['left', 'center', 'right', 'justify']).nullable(),
		overrideColor: yup.string().nullable(),
		minHeight: yup.number().nullable(),
		minWidth: yup.number().nullable(),
	})
)
